import './simplePopup.scss';

import { uniqueId } from 'lodash';
import Button from './Button';
import Popup from './Popup';

interface ISimplePopup {
  open: boolean;
  title: React.ReactNode;

  children?: React.ReactNode;

  isSingleButton?: boolean;

  confirmButtonTxt?: string;

  onCancelButtonClick?(): void;
  onConfirmButtonClick?(): void;
}

const SimplePopup = ({
  open,
  title,
  children,
  isSingleButton = false,
  confirmButtonTxt,
  onCancelButtonClick,
  onConfirmButtonClick
}: ISimplePopup) => {
  const renderButtonList = () => {
    if (isSingleButton) {
      return <Button type="button" text="확인" btnName="btn-round03" fn={() => onCancelButtonClick?.()} />;
    } else {
      return (
        <>
          <Button type="button" text="취소" btnName="btn-round02" fn={() => onCancelButtonClick?.()} />
            {confirmButtonTxt && (
              <Button type="button" text={confirmButtonTxt} btnName="btn-round03" fn={() => onConfirmButtonClick?.()} />
            )}
            {!confirmButtonTxt && (
              <Button type="button" text="확인" btnName="btn-round03" fn={() => onConfirmButtonClick?.()} />
            )}
        </>
      );
    }
  };

  return (
    <Popup
      open={open}
      popState={uniqueId('modal')}
      dialogSize="small"
      children={
        <div className="simple-popup-pc">
          <h1 className="tit">{title}</h1>
          {children && <p className="subtit">{children}</p>}

          <div className="submit-popup">{renderButtonList()}</div>
        </div>
      }
    />
  );
};

export default SimplePopup;
